
import { useState, useCallback, useEffect } from "react";
import { Header } from "@/components/Header";
import { ErrorState } from "@/components/ErrorState";
import { LoadingState } from "@/components/LoadingState";
import { MainContent } from "@/components/MainContent";
import { useAuthState } from "@/hooks/useAuthState";
import { useContentRecovery } from "@/hooks/useContentRecovery";
import { supabase } from "@/integrations/supabase/client";

const Index = () => {
  const [generatedSvg, setGeneratedSvg] = useState<string | null>(null);
  const {
    user,
    isLoadingAuth,
    error,
    recoveryAttempts,
    setRecoveryAttempts,
    recoverSession,
    MAX_RECOVERY_ATTEMPTS
  } = useAuthState();

  const handleRetry = useCallback(() => {
    setRecoveryAttempts(0);
    window.location.reload();
  }, [setRecoveryAttempts]);

  useContentRecovery(recoverSession, recoveryAttempts, setRecoveryAttempts, MAX_RECOVERY_ATTEMPTS);

  useEffect(() => {
    const redirectToGoogleAuth = async () => {
      if (!isLoadingAuth && !user && !error) {
        try {
          const { error: signInError } = await supabase.auth.signInWithOAuth({
            provider: 'google',
            options: {
              redirectTo: 'https://app.makesign.ai'
            }
          });
          
          if (signInError) {
            console.error('Google auth redirect error:', signInError);
          }
        } catch (err) {
          console.error('Failed to redirect to Google auth:', err);
        }
      }
    };

    redirectToGoogleAuth();
  }, [user, isLoadingAuth, error]);

  if (error) {
    return <ErrorState error={error} onRetry={handleRetry} />;
  }

  if (isLoadingAuth || !user) {
    return <LoadingState />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#f7f7f7]">
      <Header user={user} />
      <MainContent user={user} generatedSvg={generatedSvg} setGeneratedSvg={setGeneratedSvg} />
    </div>
  );
};

export default Index;
